import { render, staticRenderFns } from "./Irrigation.vue?vue&type=template&id=3126908b&scoped=true"
import script from "./Irrigation.vue?vue&type=script&lang=js"
export * from "./Irrigation.vue?vue&type=script&lang=js"
import style0 from "./Irrigation.vue?vue&type=style&index=0&id=3126908b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126908b",
  null
  
)

export default component.exports